import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiltersContainer } from 'components-shared';
import { useParams } from 'react-router-dom';
import TextFilter from 'components/TextFilter';
import DateFilter from 'components/DateFilter';
import StatusSelect from './StatusSelect';
import TypeSelect from './TypesSelect';
import useFilters from '../store';

const Filters = ({ apiCount }) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useFilters();
  const { type } = useParams();
  const isCenterDocument = type === 'center';

  return (
    <FiltersContainer>
      <TextFilter
        value={filters.verbatim}
        placeholder={t('audin_document.filter.text_search_placeholder')}
        onChange={(value) =>
          setFilters((prev) => ({ ...prev, verbatim: value }))
        }
      />
      {!isCenterDocument && (
        <StatusSelect
          apiCount={apiCount}
          onChange={(values) => {
            setFilters({ ...filters, step: values.join(',') })
          }}
          values={filters.step.split(',')}
        />
      )}
      <TypeSelect
        apiCount={apiCount}
        onChange={(values) => {
          setFilters({ ...filters, type: values.join(',') })
        }}
        values={filters.type.split(',')}
        isCenterDocument={isCenterDocument}
      />
      <DateFilter
        placement='left-start'
        onReset={() => {
          setFilters((prev) => ({
            ...prev,
            createdAt: { start: null, end: null },
          }))
        }}
        startDate={filters.createdAt.start}
        endDate={filters.createdAt.end}
        onStartDateChange={(value) => {
          setFilters((prev) => ({
            ...prev,
            createdAt: { ...prev.createdAt, start: value },
          }))
        }}
        onEndDateChange={(value) => {
          setFilters((prev) => ({
            ...prev,
            createdAt: { ...prev.createdAt, end: value },
          }))
        }}
        placeholderKey={'audin_document.filter.creation_date'}
        showPresets={true}
        blockFutureDates={true}
      />
    </FiltersContainer>
  );
};

export default Filters;